//--------------- IMPORTAÇÕES ---------------//
import { useContext } from "react";
import { TagsContext } from "../../context/TagsContext";
import { deleteTagService, loadTagsService } from "../../services";



//--------------- EXPORTAÇÃO DO COMPONENTE MAIN ---------------//
export default function ModalDeleteTag() {



    //--------------- CRIAÇÃO DE HOOKS ---------------//
    const { tags, setTags } = useContext(TagsContext); // Estado que armazena a lista de Tags
    const { isOpenModalDeleteTag, setIsOpenModalDeleteTag } = useContext(TagsContext);
    const { formDataModalDeleteTag, setFormDataModalDeleteTag } = useContext(TagsContext); // Estado que armazena se Tag deve ser deletada



    //--------- FUNÇÃO ASSÍNCRONA CONFIRMAR DELEÇÃO --------//
    // Nesta função, é deletada a Tag selecionada do Banco de Dados via API.
    const confirmarDelecao = async () => {
        const response = await deleteTagService(formDataModalDeleteTag.tag.id);
        if (response) {
            setFormDataModalDeleteTag(null);
            setIsOpenModalDeleteTag(false);
            handleRefreshTags();
        }
    };



    //-------- FUNÇÃO ASSÍNCRONA CARREGAR TAGS ----------//
    // Nesta função, é requisitado à API as TAGS armazenadas.
    // AS TAGS retornadas pela API são armazenadas no Estado "tags" .
    async function handleRefreshTags() {
        const response = await loadTagsService();
        if (response) {
            setTags(response.data);
        }
    };



    //--------------- RETORNO DO COMPONENTE MAIN ---------------//
    return (
        <>

            {/* DIV DE CONFIRMAÇÃO DE EXCLUSÃO DE TAG */}
            {!isOpenModalDeleteTag
                ? null
                :
                <>
                    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
                        <div className="bg-surface-1 border border-white/[0.08] rounded-xl p-6 w-full max-w-md">
                            <h2 className="text-xl font-bold mb-4">Confirmação</h2>
                            <p className="mb-4">Você tem certeza de que deseja remover esta tag?</p>
                            <div className="bg-blue-600 text-sm text-white p-3 rounded mb-4">
                                <strong>Atenção!</strong><br />
                                Ao clicar em "SIM", a tag será removida do cadastro e não poderá ser atribuída a novos leads. No entanto, os leads que já possuem essa tag continuarão a mantê-la.
                            </div>
                            <div className="flex justify-end gap-3">
                                <button
                                    onClick={() => {
                                        setFormDataModalDeleteTag(null);
                                        setIsOpenModalDeleteTag(false);
                                    }}
                                    className="px-4 py-2 bg-surface-3 hover:bg-surface-4 rounded"
                                >
                                    NÃO
                                </button>
                                <button
                                    onClick={confirmarDelecao}
                                    className="px-4 py-2 bg-brand-600 hover:bg-brand-700 rounded"
                                >
                                    SIM
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            }

        </>
    )
}